import { render } from "./UnsubcribeNewsletter.vue?vue&type=template&id=5a91de85"
import script from "./UnsubcribeNewsletter.vue?vue&type=script&lang=js"
export * from "./UnsubcribeNewsletter.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/lr-courses/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__